import { render, staticRenderFns } from "./NavItemsDraggable.vue?vue&type=template&id=2276a8d0&"
import script from "./NavItemsDraggable.vue?vue&type=script&lang=js&"
export * from "./NavItemsDraggable.vue?vue&type=script&lang=js&"
import style0 from "./NavItemsDraggable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports